import script from "./CasinoComponentForAll.vue?vue&type=script&setup=true&lang=ts"
export * from "./CasinoComponentForAll.vue?vue&type=script&setup=true&lang=ts"

import "./CasinoComponentForAll.vue?vue&type=style&index=0&id=663eaffe&lang=css"

const __exports__ = script;

export default __exports__